import axios_instance from "../axios.config";

const GetWardCategoryReport = async (newItem) => {
  try{
    const {
      class_id,
      section_id
    } = newItem;
  
    const payload = { class_id, section_id };
    const response = await axios_instance.post(
      "/student/get-ward-category-report",
      payload
    );
    console.log(response);
    if (response?.data?.status === "SUCCESS") {
      return response.data;
    } else {
      return [];
    }
  } catch(err){
    console.error("Error fetching ward category report:", err);
    return null;
  }
};

export {
  GetWardCategoryReport
}